export default __webpack_public_path__ + "static/media/zukunf_lauft_s2.3d860a5e.png";